import { IStore } from 'modules/types';

export const isTourActive = (state: IStore) => state.tour.is_tour_active;